// 更多规则可查看 https://github.com/any86/any-rule

/**
 * 验证手机号
 * @param {string} str
 * @returns {Boolean}
 */
export function checkPhone(phone) {
  return /^1[3456789]\d{9}$/.test(phone);
}

/**
 * 验证6位手机验证码
 * @param {string} str
 * @returns {Boolean}
 */
export function check6Code(code) {
  return /^\d{6}$/.test(code);
}

// 身份证号强校验
const validateIDCard = (idCard) => {
  // 正则表达式，用于匹配身份证号码（18位数字）
  var idCardRegex = /^\d{17}(\d|X|x)$/;

  // 使用正则表达式测试输入的身份证号码
  if (idCardRegex.test(idCard)) {
    // 系数数组
    var coefficientArr = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
    // 校验位对应值数组
    var checkCodeArr = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];

    // 计算加权和
    var weightedSum = 0;
    for (var i = 0; i < 17; i++) {
      weightedSum += parseInt(idCard.charAt(i)) * coefficientArr[i];
    }

    // 计算校验位的索引
    var checkCodeIndex = weightedSum % 11;

    // 获取校验位
    var checkCode = checkCodeArr[checkCodeIndex];

    // 校验位匹配则返回true，否则返回false
    return (
      idCard.charAt(17).toUpperCase() === checkCode.toString().toUpperCase()
    );
  } else {
    // 如果不是18位数字则直接返回false
    return false;
  }
};

/**
 * 验证身份证号, 支持1/2代(15位/18位数字)
 * @param {string} str
 * @returns {Boolean}
 */
export function checkIdNumber(idNumber) {
  if (idNumber) {
    // return /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0[1-9]|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/.test(
    //   idNumber
    // );

    // 强校验
    return validateIDCard(idNumber);
  }
}

// 验证邮箱
export function checkEamil(email) {
  if (email) {
    return /^[a-zA-Z0-9]+@[a-z0-9]{2,5}\.[a-z]{2,3}(\.[a-z]{2,3})?$/.test(
      email
    );
  }
}

// 手机号脱敏
export function fillPhone(str) {
  const pat = /(\d{3})\d*(\d{4})/;
  if (str) {
    const b = str.replace(pat, "$1****$2");
    return b;
  }
}

/**
 * 验证账号, 帐号是否合法(字母开头，允许6-18字节，允许字母数字下划线组合）
 * @param {string} str
 * @returns {Boolean}
 */
export function checkAccount(account) {
  return /^[a-zA-Z]\w{5,17}$/.test(account);
}

/**
 * 验证是否是字符串
 * @param {string} str
 * @returns {Boolean}
 */
export function isString(str) {
  if (typeof str === "string" || str instanceof String) {
    return true;
  }
  return false;
}

/**
 * 验证是否是数组
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isArray(arg) {
  if (typeof Array.isArray === "undefined") {
    return Object.prototype.toString.call(arg) === "[object Array]";
  }
  return Array.isArray(arg);
}

/**
 * 验证是否是数字
 * @param {number} number
 * @returns {Boolean}
 */
export function checkNumber(number) {
  return /^[0-9]+$/.test(number);
}
/**
 * 验证是否是小数
 * @param {number} number
 * @returns {Boolean}
 */
export function checkFloatNumber(number) {
  return /^\d+\.\d+$/.test(number);
}

/**
 * 验证是否是字母
 * @param {string} str
 * @returns {Boolean}
 */
export function validAlphabets(str) {
  const reg = /^[A-Za-z]+$/;
  return reg.test(str);
}

/**
 * 验证是否都是小写字母
 * @param {string} str
 * @returns {Boolean}
 */
export function validLowerCase(str) {
  const reg = /^[a-z]+$/;
  return reg.test(str);
}

/**
 * 验证是否都是大写字母
 * @param {string} str
 * @returns {Boolean}
 */
export function validUpperCase(str) {
  const reg = /^[A-Z]+$/;
  return reg.test(str);
}

/**
 * 验证账号, 是否是数字和字母
 * @param {string} str
 * @returns {Boolean}
 */
export function checkStringAndNumber(account) {
  return /^[A-Za-z0-9]+$/.test(account);
}
